import { render, staticRenderFns } from "./ghacTab.vue?vue&type=template&id=8a7ff18c&"
import script from "./ghacTab.vue?vue&type=script&lang=js&"
export * from "./ghacTab.vue?vue&type=script&lang=js&"
import style0 from "./ghacTab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports